import $ from 'jquery';

/**
 * Toggle a checkbox to show/hide Organisation name field
 */
const initOrganisationField = callback => {
    const $checkboxWrap = $('.js-organisation-checkbox');
    const $fieldWrap = $('.js-organisation-field');
    if ($checkboxWrap.length) {
        $checkboxWrap.on('change', 'input', e => {
            const $checkbox = $(e.currentTarget);
            if ($checkbox.prop('checked')) {
                // 1. If checked, show organisation name field.
                $fieldWrap.removeClass('sr-only').slideDown(0); // to remove "display: none" from jQuery.slideUp();
                $fieldWrap.addClass('jsv-text');
                callback();
            } else {
                // 2. If unchecked, hide organisation name field.
                $fieldWrap.slideUp('fast', () => {
                    $fieldWrap.addClass('sr-only').slideDown(0);
                });
                $fieldWrap.removeClass('jsv-text');
                $fieldWrap.find('input').val('');
            }
        });
    }
};

export default initOrganisationField;



// WEBPACK FOOTER //
// ./src/components/form-elements/c-organisation.js